import React, { Component } from 'react'
import { InputItem } from 'antd-mobile'

//修复安卓7.0中webview中 ant desgin inputItem组件bug
class CustomerInput extends InputItem{
  constructor(props){
    super(props)
    this.onInputChange= function(e){
      props.onChange(e.target.value)
    }
  }
}

export default CustomerInput